<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();

async function updateSetting(value: boolean) {
  await settingsStore.set('hideEmptyWeekendsInOverview', value);
}
</script>

<template>
  <SettingsToggle
    :checked="settingsStore.settings.hideEmptyWeekendsInOverview"
    :label="t('hourRegistration.hideWeekendFromOverview')"
    :description="t('hourRegistration.hideWeekendFromOverviewDescription')"
    @change="updateSetting"
  />
</template>